import axios from '../../services/axios.service';
import { getEndpointBase } from '../../services/api.service';
import { JobParams } from './Job.type';

let listRequest: any = null;
let typesListRequest: any = null;

const jobService = {
  getList({ search = '', page = 1, ...params }: JobParams) {
    listRequest && listRequest.cancel();
    listRequest = axios.CancelToken.source();
    return axios.get(getEndpointBase(`jobs`), {
      cancelToken: listRequest.token,
      params: {
        search,
        page,
        filter: {
          ...params,
        },
      },
    });
  },
  getTypes({ ids }: any) {
    typesListRequest && typesListRequest.cancel();
    typesListRequest = axios.CancelToken.source();
    return axios.get(getEndpointBase(`jobs/types`), {
      cancelToken: typesListRequest.token,
      params: {
        filter: {
          ids,
        },
      },
    });
  },
};

export default jobService;
